var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAttackPlanet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1282,
    height: 1283,
    viewBox: "0 0 1282 1283",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 640.953,
    cy: 641.298,
    r: 637.731,
    fill: "#826C73"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M394.795 261.116C415.118 158.01 254.342 183.306 171.414 208.842C336.687 40.3039 764.644 -185.195 1154.29 261.116C1126.84 278.841 1073.7 289.957 988.726 261.116C865.21 219.193 760.089 282.122 643.58 314.291C552.184 339.527 374.472 364.222 394.795 261.116Z",
    fill: "#6B4F70"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M171.415 212.055C254.343 187.235 415.119 162.649 394.796 262.864C374.473 363.078 552.185 339.076 643.581 314.548C760.09 283.28 865.211 222.116 988.727 262.864C1073.7 290.896 1126.84 280.092 1154.29 262.864",
    stroke: "black",
    strokeWidth: 6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M477.14 566.837C200.323 714.707 45.8539 660.57 3.22168 615.017C3.22168 765.69 57.534 895.047 84.6901 940.891C115.058 899.427 209.022 855.575 288.799 884.827C367.64 913.735 435.092 940.891 522.692 913.735C692.293 861.159 829.819 820.353 933.538 884.827C1037.26 949.301 1163.05 932.715 1212.98 916.363C1280.26 797.927 1283.65 642.758 1276.93 579.977C1258.01 538.63 1155.75 597.205 1106.99 631.661C936.692 758.507 867.838 673.418 854.698 615.017C844.186 537.345 753.957 418.968 477.14 566.837Z",
    fill: "#6B4F70"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1213.86 921.399C1163.93 937.751 1038.13 954.337 934.415 889.863C830.696 825.389 693.169 866.195 523.569 918.771C435.968 945.927 368.516 918.771 289.675 889.863C209.898 860.612 115.935 904.463 85.5664 945.927",
    stroke: "black",
    strokeWidth: 6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.22168 615.017C45.8539 660.57 200.323 714.707 477.14 566.837C753.957 418.968 844.186 537.345 854.698 615.017C867.838 673.418 936.692 758.507 1106.99 631.661C1155.75 597.205 1258.01 538.63 1276.93 579.977",
    stroke: "black",
    strokeWidth: 6
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M736.437 1159.89C600.481 1101.73 441.807 1178.29 384.283 1222.96C634.47 1351.21 925.654 1234.35 1017.63 1155.51C996.61 1134.49 969.58 1141.71 950.182 1159.89C922.15 1186.17 872.393 1218.06 736.437 1159.89Z",
    fill: "#6B4F70"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M384.283 1222.96C441.807 1178.29 600.481 1101.73 736.437 1159.89C872.393 1218.06 922.15 1186.17 950.182 1159.89C969.58 1141.71 996.61 1134.49 1017.63 1155.51",
    stroke: "black",
    strokeWidth: 6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 640.953,
    cy: 641.298,
    r: 637.731,
    stroke: "black",
    strokeWidth: 6
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttackPlanet);
export default __webpack_public_path__ + "static/media/attack-planet.d323e769f20d444e543e25b16f4a7787.svg";
export { ForwardRef as ReactComponent };